import type { ProductCard } from 'models/productCard';
import type { ExtractStrict } from 'types';

import type { StatusType } from './statusType';

type WebStock = Pick<
	ProductCard,
	'isSellable' | 'isSellableOnWeb' | 'productReStockWeb'
>;

export function getProductCardWebStockStatus({
	isSellable,
	isSellableOnWeb,
	productReStockWeb,
}: WebStock): ProductCardWebStockStatusType {
	switch (true) {
		case isSellable && isSellableOnWeb:
			return 'InStock';
		case !isSellable && isSellableOnWeb && !productReStockWeb:
			return 'OutOfStock';
		case !isSellable && isSellableOnWeb && productReStockWeb:
			return 'ReStock-NotWatchable';
		case !isSellableOnWeb:
			return 'InStoreOnly';
		default:
			return 'MatchFailed';
	}
}

export type ProductCardWebStockStatusType = ExtractStrict<
	StatusType,
	| 'InStock'
	| 'InStoreOnly'
	| 'MatchFailed'
	| 'OutOfStock'
	| 'ReStock-NotWatchable'
>;
